import React from 'react';
import CascadingApprovalSummaryCard from './components/CascadingApprovalSummaryIndex.jsx';

const CascadingApprovalSummary = () => (
  <div>
    <CascadingApprovalSummaryCard />
  </div>
);

export default CascadingApprovalSummary;
